import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useRef } from 'react';
import { Offer, PaymentInterfaceNew } from '../../../new-lib/types/entity';
import { EntityTypes } from '../../../new-lib/constants/common';
import useScrollToPlans from '../../../hooks/ScrollToPlans';
import InformativePlan from '../components/payment-plans/InformativePlan';
import CompoundOfferPlan from '../components/payment-plans/CompoundOfferPlan';

interface ChildProps {
  plans: PaymentInterfaceNew[];
  offers: Offer[];
  entityType: EntityTypes;
}

const PaymentPlansPresentation = ({ plans, offers }: ChildProps) => {
  const { t } = useTranslation('entity');
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const paymentPlansRef = useRef<HTMLDivElement>(null);

  useScrollToPlans(paymentPlansRef);

  const getCompoundPlans = () => {
    return (
      <>
        {offers.map((offer, index) => (
          <CompoundOfferPlan key={index} offer={offer} />
        ))}
        {plans.slice(0, 3).map((plan, index) => (
          <InformativePlan key={index} plan={plan} />
        ))}
      </>
    );
  };

  return (
    <PaymentDetails
      data-test="payment-plans"
      itemScope
      itemType="http://schema.org/PaymentService"
      ref={paymentPlansRef}
    >
      <h2 className="headline-3 entity-title">{t('payment_plans')}</h2>
      <div
        className={`${
          isMobile ? 'payments-container-mob' : 'payments-container'
        }`}
      >
        {getCompoundPlans()}
      </div>
    </PaymentDetails>
  );
};

const PaymentDetails = styled.div`
  .payments-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;

    &.property-plan {
      flex-direction: column;
      gap: 24px;
    }
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.tablet.max}) {
    .headline-1 {
      font-size: ${props => props.theme.font.sizes.l};
      margin-bottom: 5px;
    }

    .payments-container {
      flex-wrap: nowrap;
      gap: 8px;
      overflow-x: auto;

      ::-webkit-scrollbar {
        display: none;
      }
      -ms-overflow-style: none; /* IE 11 */
      scrollbar-width: none; /* Firefox 64 */

      &.property-plan {
        gap: 16px;
      }
    }
  }
`;

export default PaymentPlansPresentation;
